module.exports = __webpack_public_path__ + "img/liushui (3).7cb8f386.png";